export default "__VITE_ASSET__i4nqF6QR__$_?url__"